import React, { useState, useEffect } from "react";
import { QRCode } from "react-qrcode-logo";
import { ReptoolModal } from "../../utilities/ReptoolModal.tsx";
import { BasicFetch } from "../../../utils/BasicFetch.ts";
import { Button } from "react-bootstrap";
import { useRepToolContext } from '../../../RepToolContext.tsx';
const ReptileSharingOff = () => {
  const [updating, setUpdating] = useState(false);

  const toggleSharing = () => {
    BasicFetch({
      url: `${(window as any).serverLocation}/user/toggle_sharing`,
      method: 'POST',
      data: {},
      onSuccess: ({ user }) => {
        alert('Sharing settings successfully turned on');
        (window as any).currentUser = user;
      },
      onFail: () => {
        alert('Failed to update sharing settings');
      },
      onFinish: () => {
        setUpdating(false);
      }
    })
  }

  useEffect(() => {
    if (updating) {
      toggleSharing();
    }
  }, [updating])


  return (
    <div className="text-center">
      <h5>Reptile sharing is currently turned off.</h5>
      <p className="text-light">
        Reptile sharing allows you to share your available reptiles with others. Turn it on to share your available reptiles with others. This will allow others to see your available reptiles and contact you about them. You can turn this off at any time.
      </p>
      <Button onClick={() => setUpdating(true)} disabled={updating} variant="primary">{updating ? "Updating..." : "Turn Sharing On"}</Button>
    </div>
  )
}

const ReptileSharingOn = () => {
  const [updating, setUpdating] = useState(false);
  const url = `${(window as any).serverLocation}collection_reptile/${(window as any).currentUser.id}/available`;

  const toggleSharing = () => {
    BasicFetch({
      url: `${(window as any).serverLocation}/user/toggle_sharing`,
      method: 'POST',
      data: {},
      onSuccess: ({ user }) => {
        alert('Sharing settings successfully turned off');
        (window as any).currentUser = user;
      },
      onFail: () => {
        alert('Failed to turn off sharing settings');
      },
      onFinish: () => {
        setUpdating(false);
      }
    })
  }

  useEffect(() => {
    if (updating) {
      toggleSharing();
    }
  }, [updating])

  return (
    <div className="text-center">
      <h5>Share your available reptiles with others by scanning the QR code below.</h5>

      <div className="border border-dashed rounded border-dark bg-white text-dark p-2 p-md-3 my-4 col-md-8 mx-auto">
        <p style={{ fontSize: '1.25rem' }}>Check out our available reptiles by scanning the code below!</p>
        <QRCode
          value={url}
          logoImage="/images/white-logo.jpg"
          logoWidth={64}
          logoHeight={64}
          size={256}
        />
      </div>
      <p className="mt-3 text-light mb-1">Or share this link:</p>
      <p className="text-truncate"><a href={
        url
      }>{url}</a></p>
      <div className="d-flex flex-column">
        <Button variant="outline-light" className="mb-2" onClick={
          () => {
            navigator.clipboard.writeText(url);
            alert('Link copied to clipboard');
          }
        }>
          Copy Link
        </Button>
        <Button variant="secondary" onClick={() => setUpdating(true)}>Turn Sharing Off</Button>
      </div>
    </div>
  )
}


export const ShareAvailableReptilesModal = ({ closeModal }: {
  closeModal: (sharingTurnedOn: boolean) => void
}) => {
  const availableReptilesVisible = (window as any).currentUser.available_reptiles_visible;
  const { appendControls } = useRepToolContext();
  useEffect(() => {
    appendControls(null, 'Share Available Reptiles Modal');
  }, [])
  return (
    <ReptoolModal closeModal={() => closeModal(availableReptilesVisible)} id="share-modal" title="Share Available Reptiles" body={
      <div className="text-center">
        {availableReptilesVisible ?
          <ReptileSharingOn /> : <ReptileSharingOff />}
      </div>
    } />
  )
}